import { free } from './free.js';
/**
 * Parse a FreeSpaceBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed FreeSpaceBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function skip(view) {
    return free(view);
}
;
//# sourceMappingURL=skip.js.map